// Skills record where they start (startPosition). For one that doesn't yet,
// the name is the guide: a Cody (front to feet) or a Ball-out (back to feet)
// lands on the feet after 1¼, and "From …" names say where they start.
export const STARTS_OFF_FEET = /\bfrom\b|\bto feet\b|ball-?out|\bcody\b|swivel\s*hips|\bcradle\b|\bcruise\b|\bseat\b|stomach|pull-?over|turn-?over|kaboom|corkscrew|cat\s*twist|\broller\b/i;

export function startsOffFeet(skill) {
  if (skill.startPosition) return skill.startPosition !== 'feet';
  return STARTS_OFF_FEET.test(skill.name || '');
}

export function isFeetToFeet(skill) {
  if (skill.landing !== 'feet') return false;
  if (skill.quarterSoms != null && skill.quarterSoms % 4 !== 0) return false;
  return !startsOffFeet(skill);
}
